import React from 'react';
import { Star } from 'lucide-react';

export function StarDisplay({ rating = 5, size = 16, className = '' }) {
  const n = Math.max(0, Math.min(5, Number(rating) || 0));
  return (
    <span className={`jet-stars jet-stars--display ${className}`} aria-label={`${n} out of 5 stars`}>
      {[1, 2, 3, 4, 5].map((i) => (
        <Star
          key={i}
          className={`jet-star ${i <= n ? 'jet-star--filled' : 'jet-star--empty'}`}
          width={size}
          height={size}
          fill={i <= n ? 'currentColor' : 'none'}
          aria-hidden
        />
      ))}
    </span>
  );
}

export default function StarRatingInput({ value, onChange, size = 28, disabled = false }) {
  const [hover, setHover] = React.useState(0);
  const active = hover || value || 0;

  return (
    <div
      className="jet-stars jet-stars--input"
      role="radiogroup"
      aria-label="Rating"
      onMouseLeave={() => setHover(0)}
    >
      {[1, 2, 3, 4, 5].map((i) => (
        <button
          key={i}
          type="button"
          role="radio"
          aria-checked={value === i}
          disabled={disabled}
          className={`jet-star-btn ${i <= active ? 'jet-star-btn--active' : ''}`}
          onMouseEnter={() => setHover(i)}
          onFocus={() => setHover(i)}
          onBlur={() => setHover(0)}
          onClick={() => onChange(i)}
        >
          <Star width={size} height={size} fill={i <= active ? 'currentColor' : 'none'} aria-hidden />
          <span className="sr-only">{i} star{i > 1 ? 's' : ''}</span>
        </button>
      ))}
    </div>
  );
}
